/***** DESKTOP *******/
(function ($) {

    function getCookie(cname) {
        var name = cname + "=",
            ca = document.cookie.split(';'),
            i,
            c,
            ca_length = ca.length;
        for (i = 0; i < ca_length; i += 1) {
            c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) !== -1) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }    

    var $candidate_token = getCookie('TDATA') || '';    

    var isLoggedIn = false;

    if ($candidate_token.length > 0) {

        var isUsa = (window.location.pathname || '').toLowerCase().startsWith('/us')
            || (window.location.pathname || '').toLowerCase().startsWith('/us/');

        var url = '/api/candidate/ActiveSessionCheck/?isUsa=' + isUsa;
        $.get(url, function (data, status) {
            //console.log("ActiveSessionCheck Data: ", data, status);
            processCandidateLogic(data.messageID == '1');
        });

    } else {
        processCandidateLogic(false);
    }


    function processCandidateLogic(loggedIn) {
        // console.log('processCandidateLogic', loggedIn);

        if (loggedIn == true) {

            $('.pre-header-links .users-links').removeClass('d-none');

            // hide anonymous in area
            // show logged area

        } else {
            $('.pre-header-links .guests-links').removeClass('d-none');
            $('.dropdown-langauge-selector').removeClass('d-none');
            // hide logged in area
            // show anonymous area
        }
    }

})(jQuery);


